<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" :class="{scrolled: scrolled}"></Header>
    <div class="icel-cop-29">
      <div class="cnt">
        <h3>ICEL AT COP29</h3>
      </div>
    </div>
    <div class="menu-cnt">
      <div class="cnt">
        <div class="menu loading" v-if="loading">
          <div class="menu-item">
            <span>Loading...</span>
          </div>
          <div class="menu-item">
            <span>Loading...</span>
          </div>
          <div class="menu-item">
            <span>Loading...</span>
          </div>
        </div>
        <div class="menu loading" v-else>
          <div class="menu-item" :class="{active: tab === menu.code}" v-on:click="tab = menu.code"
            v-for="(menu, i) in tabs" :key="i">
            {{menu.name}}
          </div>
        </div>
      </div>
    </div>

    <div class="cop-content loading" v-if="loadingContent">
      <div class="cnt">
        <h4 class="cop-title">Loading...</h4>
        <div class="content-title">
        </div>
        <div class="the-content">
          <div class="l1"></div>
          <div class="l2"></div>
          <div class="l3"></div>
        </div>
      </div>
    </div>

    <template v-if="tab === 'icel-focus-on-cop'">
      <div class="cop-content">
        <div class="cnt" v-for="(article, i) of articles" :key="i">
          <div v-for="(meta, i2) of article.metadata" :key="i2">
            <h4 class="cop-title" v-if="meta.label[lang] === 'COP29-Title'">
              {{meta.value[lang]}}
            </h4>
          </div>
          <div class="content-title">
            {{article.title[lang]}}
          </div>
          <div class="authorInfo" v-if="article.displayAuthor
            || article.displayPublishDate || article.displayViews"
            :class="{noAuthor: !article.displayAuthor}">
            <div class="authorImg"></div>
            <h4 v-if="article.author && article.displayAuthor">
              {{article.author.name}}</h4>
            <div class="publishTime"
              v-if="article.displayPublishDate || article.displayViews">
              <span class="timestamp" v-if="article.publishDate
                && article.displayPublishDate">
                {{article.publishDate | moment(article.dateFormat)}}
              </span>
              <span class="timestamp" v-if="article.displayViews">
                <span class="bull" v-if="article.displayPublishDate">&bull;</span>
                <template v-if="article.viewCount > 1">
                  <template v-if="article.viewCount >= 1000000000">
                    {{Math.floor(article.viewCount/1000000000).toLocaleString('id')}}b
                  </template>
                  <template v-else-if="article.viewCount >= 1000000">
                    {{Math.floor(article.viewCount/1000000).toLocaleString('id')}}m
                  </template>
                  <template v-if="article.viewCount >= 1000">
                    {{Math.floor(article.viewCount/1000).toLocaleString('id')}}k
                  </template>
                  <template v-else-if="article.viewCount">
                    {{article.viewCount.toLocaleString('id')}}
                  </template>
                  views
                </template>
                <template v-else>{{article.viewCount || 0}} view</template>
              </span>
            </div>
          </div>
          <template v-if="article.useHeaderImg === 1">
            <div class="articleHeaderImg" v-if="article.thumbHd && article.thumbHd[lang]"
              :style="{'background-image': `url(${article.thumbHd[lang]})`}"
              :class="[article.coverStyle, {protected: article.isProtected}]">
              <img :src="article.thumbHd[lang]" v-if="article.coverStyle === 'full'"
                v-on:load="changeBaseShareTop">
              <div class="protectedContent" v-if="article.isProtected">
                <div class="protectedContentIn">
                  <img src="../assets/padlock-white.png">
                  <h4 v-if="lang === 'en'">Locked Content</h4>
                  <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                </div>
              </div>
            </div>
            <div class="articleHeaderImg noImg" v-else
              :class="{protected: article.isProtected}">
              <div class="protectedContent" v-if="article.isProtected">
                <div class="protectedContentIn">
                  <img src="../assets/padlock-white.png">
                  <h4 v-if="lang === 'en'">Locked Content</h4>
                  <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                </div>
              </div>
            </div>
          </template>
          <div class="the-content" v-html="article.content[lang]"></div>
          <div class="articleShare articleShareStatic" v-if="article.displayShare">
            <h4 v-if="lang === 'id'">Bagikan</h4>
            <h4 v-if="lang === 'en'">Share</h4>
            <div class="shareCnt">
              <a target="_blank"
                :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
                <i class="fa fa-facebook fa-fw"></i>
              </a>
              <a target="_blank"
                :href="`https://twitter.com/intent/tweet?text=${article.title}&amp;url=${shareUri}`">
                <i class="fa fa-twitter fa-fw"></i>
              </a>
              <a :href="`whatsapp://send?text=${article.title} ${shareUri}`">
                <i class="fa fa-whatsapp fa-fw"></i>
              </a>
              <a target="_blank"
                :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${article.title}`">
                <i class="fa fa-telegram fa-fw"></i>
              </a>
              <a :href="`mailto:?subject=${article.title}&amp;body=Check this out:
                <a href='${shareUri}'>${article.title}</a>`">
                <i class="fa fa-email fa-fw"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="more-cop" v-if="articlesMores.length > 0">
        <div class="cnt">
          <div v-for="(meta, i) of articlesMores[0].metadata" :key="i">
            <h4 class="more-title" v-if="meta.label[lang] === 'More-Title'">
              {{meta.value[lang]}}
            </h4>
          </div>
          <div class="more-cnt">
            <a :href="item.linkUrl"
              :style="{'background-image': `url(${item.thumbHd[lang]})`}"
              class="more-item" v-for="(item, i) in articlesMores" :key="i">
              <h4>
                {{ item.title[lang] }}
                <img src="../assets/arrow-next.png">
              </h4>
            </a>
          </div>
        </div>
      </div>
    </template>

    <template v-if="tab === 'icel-activities'">
      <div class="cop-content">
        <div class="cnt">
          <div class="activity">
            <div class="activity-item" v-for="(article, i) in activities" :key="i">
              <div class="content-title">
                {{article.title[lang]}}
              </div>
              <div class="authorInfo" v-if="article.displayAuthor
                || article.displayPublishDate || article.displayViews"
                :class="{noAuthor: !article.displayAuthor}">
                <div class="authorImg"></div>
                <h4 v-if="article.author && article.displayAuthor">
                  {{article.author.name}}</h4>
                <div class="publishTime"
                  v-if="article.displayPublishDate || article.displayViews">
                  <span class="timestamp" v-if="article.publishDate
                    && article.displayPublishDate">
                    {{article.publishDate | moment(article.dateFormat)}}
                  </span>
                  <span class="timestamp" v-if="article.displayViews">
                    <span class="bull" v-if="article.displayPublishDate">&bull;</span>
                    <template v-if="article.viewCount > 1">
                      <template v-if="article.viewCount >= 1000000000">
                        {{Math.floor(article.viewCount/1000000000).toLocaleString('id')}}b
                      </template>
                      <template v-else-if="article.viewCount >= 1000000">
                        {{Math.floor(article.viewCount/1000000).toLocaleString('id')}}m
                      </template>
                      <template v-if="article.viewCount >= 1000">
                        {{Math.floor(article.viewCount/1000).toLocaleString('id')}}k
                      </template>
                      <template v-else-if="article.viewCount">
                        {{article.viewCount.toLocaleString('id')}}
                      </template>
                      views
                    </template>
                    <template v-else>{{article.viewCount || 0}} view</template>
                  </span>
                </div>
              </div>
              <template v-if="article.useHeaderImg === 1">
                <div class="articleHeaderImg" v-if="article.thumbHd && article.thumbHd[lang]"
                  :style="{'background-image': `url(${article.thumbHd[lang]})`}"
                  :class="[article.coverStyle, {protected: article.isProtected}]">
                  <img :src="article.thumbHd[lang]" v-if="article.coverStyle === 'full'"
                    v-on:load="changeBaseShareTop">
                  <div class="protectedContent" v-if="article.isProtected">
                    <div class="protectedContentIn">
                      <img src="../assets/padlock-white.png">
                      <h4 v-if="lang === 'en'">Locked Content</h4>
                      <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                    </div>
                  </div>
                </div>
                <div class="articleHeaderImg noImg" v-else
                  :class="{protected: article.isProtected}">
                  <div class="protectedContent" v-if="article.isProtected">
                    <div class="protectedContentIn">
                      <img src="../assets/padlock-white.png">
                      <h4 v-if="lang === 'en'">Locked Content</h4>
                      <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                    </div>
                  </div>
                </div>
              </template>
              <div class="the-content" v-html="article.content[lang]"></div>
              <div class="articleShare articleShareStatic" v-if="article.displayShare">
                <h4 v-if="lang === 'id'">Bagikan</h4>
                <h4 v-if="lang === 'en'">Share</h4>
                <div class="shareCnt">
                  <a target="_blank"
                    :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
                    <i class="fa fa-facebook fa-fw"></i>
                  </a>
                  <a target="_blank"
                    :href="`https://twitter.com/intent/tweet?text=${article.title}&amp;url=${shareUri}`">
                    <i class="fa fa-twitter fa-fw"></i>
                  </a>
                  <a :href="`whatsapp://send?text=${article.title} ${shareUri}`">
                    <i class="fa fa-whatsapp fa-fw"></i>
                  </a>
                  <a target="_blank"
                    :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${article.title}`">
                    <i class="fa fa-telegram fa-fw"></i>
                  </a>
                  <a :href="`mailto:?subject=${article.title}&amp;body=Check this out:
                    <a href='${shareUri}'>${article.title}</a>`">
                    <i class="fa fa-email fa-fw"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more-cop" v-if="activitiesMores.length > 0">
        <div class="cnt">
          <div v-for="(meta, i) of activitiesMores[0].metadata" :key="i">
            <h4 class="more-title" v-if="meta.label[lang] === 'More-Title'">
              {{meta.value[lang]}}
            </h4>
          </div>
          <div class="more-cnt">
            <a :href="item.linkUrl"
              :style="{'background-image': `url(${item.thumbHd[lang]})`}"
              class="more-item" v-for="(item, i) in activitiesMores" :key="i">
              <h4>
                {{ item.title[lang] }}
                <img src="../assets/arrow-next.png">
              </h4>
            </a>
          </div>
        </div>
      </div>
    </template>

    <template v-if="tab === 'icel-delegates'">
      <div class="cop-content">
        <div class="cnt">
          <div class="cop29-team">
            <div v-for="(meta, i) of deletgates[0].metadata" :key="i">
            <h4 class="team-title" v-if="meta.label[lang] === 'Delegates-Title'">
              {{meta.value[lang]}}
            </h4>
          </div>
            <div class="team-cnt">
              <div class="team-item" v-for="(item, i) of deletgates" :key="i">
                <div class="team-img"
                  :style="{'background-image': `url(${item.thumbHd[lang]})`}"></div>
                <div class="team-info">
                  <h4>{{item.title[lang]}}</h4>
                  <p>{{item.description[lang]}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contact-cop29" v-for="(item, i) in deletgatesArticles" :key="i">
        <div class="cnt">
          <div class="contact-cnt"
            :style="{'background-image': `url(${item.thumbHd[lang]})`}">
            <div class="contact-info">
              <div class="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" class="lucide lucide-phone">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0
                  1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84
                  0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1
                  2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              {{item.title[lang]}}
            </div>
            <h4 v-html="item.content[lang]"></h4>
          </div>
        </div>
      </div>
      <div class="more-cop" v-if="deletgatesMores.length > 0">
        <div class="cnt">
          <div v-for="(meta, i) of deletgatesMores[0].metadata" :key="i">
            <h4 class="more-title" v-if="meta.label[lang] === 'More-Title'">
              {{meta.value[lang]}}
            </h4>
          </div>
          <div class="more-cnt">
            <a :href="item.linkUrl"
              :style="{'background-image': `url(${item.thumbHd[lang]})`}"
              class="more-item" v-for="(item, i) in deletgatesMores" :key="i">
              <h4>
                {{ item.title[lang] }}
                <img src="../assets/arrow-next.png">
              </h4>
            </a>
          </div>
        </div>
      </div>
    </template>
    <Footer></Footer>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'cop29',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      scrolled: false,
      tab: 'article',
      tabs: [],
      loading: true,
      loadingContent: true,
      articles: [],
      articlesMores: [],
      activities: [],
      activitiesMores: [],
      deletgates: [],
      deletgatesMores: [],
      deletgatesArticles: [],
      general: [],
      shareUri: '',

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.scrollY >= 30);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    this.shareUri = `${this.$config.appUri}${this.$route.fullPath}`;

    this.$http.get(this.$config.uri('article/directory/cop29')).then((r) => {
      this.tabs = r.data.data.submenu;
      this.tab = this.tabs[0].code;
      this.loading = false;
      // eslint-disable-next-line
      for (const item of this.tabs) {
        this.$http.get(this.$config.uri(`article/all?directoryId=${item.id}`)).then((r2) => {
          this.loadingContent = false;
          if (item.code === 'icel-focus-on-cop') {
            // eslint-disable-next-line
            for (const article of r2.data.data) {
              if (article.type === 'article') this.articles.push(article);
              else if (article.type === 'link') this.articlesMores.push(article);
            }
          } else if (item.code === 'icel-activities') {
            // eslint-disable-next-line
            for (const article of r2.data.data) {
              if (article.type === 'article') this.activities.push(article);
              else if (article.type === 'link') this.activitiesMores.push(article);
            }
          } else if (item.code === 'icel-delegates') {
            // eslint-disable-next-line
            for (const article of r2.data.data) {
              if (article.type === 'profile') this.deletgates.push(article);
              else if (article.type === 'link') this.deletgatesMores.push(article);
              else if (article.type === 'article') this.deletgatesArticles.push(article);
            }
          }
        });
      }
    });
  },
};
</script>

<style lang="scss">
.cop-content{
  .the-content{
    font-size: 19px;
    line-height: 1.7;
    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 1.6;
    }
    blockquote{
      padding-left: 36px;
      border-left: #444 4px solid;
      margin: 0 !important;
      font-size: inherit !important;
      line-height: inherit !important;
      font-family: inherit !important;
      background: none !important;
    }
    ol, ul{
      margin: 0;
      padding: 0;
      padding-left: 19px;
      li{
        padding-left: 20px;
      }
    }
    p{
      margin: 0 !important;
      font-size: inherit !important;
      line-height: inherit !important;
      font-family: inherit !important;
      background: none !important;
      *{
        margin: 0 !important;
        font-size: inherit !important;
        line-height: inherit !important;
        font-family: inherit !important;
        background: none !important;
      }
    }
  }
}

.contact-cop29{
  .cnt{
    h4{
      *{
        margin: 0 !important;
        font-size: inherit !important;
        line-height: inherit !important;
        font-family: inherit !important;
        background: none !important;
      }
      a{
        color: inherit;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.icel-cop-29{
  background-image: url(../assets/icel-cop29-bg.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .cnt{
    padding: 30px 0;
    position: relative;
    h3{
      font-size: 120px;
      line-height: 0;
      color: #fff;
      text-shadow: 4px 4px 12px rgba($color: #000000, $alpha: .4);
      @media (max-width: 1024px) {
        font-size: 80px;
      }
      @media (max-width: 768px) {
        font-size: 36px;
      }
    }
  }
}

.menu-cnt{
  border-bottom: #999 3px solid;
}
.menu{
  display: flex;
  justify-content: flex-end;
  gap: 40px;
  .menu-item{
    padding: 16px 0 14px;
    font-size: 18px;
    font-weight: 500;
    position: relative;
    color: #767676;
    transition: all .3s ease;
    cursor: pointer;
    @media (max-width: 768px) {
      padding: 12px 0 8px;
      font-size: 16px;
    }
    &:hover{
      color: #222;
    }
    &::before{
      content: "";
      position: absolute;
      left: 0; right: 0;
      bottom: -3px;
      height: 3px;
      transition: all .3s ease;
    }
    &.active{
      color: #008552;
      &::before{
        background-color: #008552;
      }
    }
  }
  &.loading{
    .menu-item{
      span{
        background-color: #e5e5e5;
        color: #e5e5e5;
        border-radius: 50px;
        min-width: 120px;
        display: inline-block;
      }
    }
  }
}

.cop-content{
  padding: 74px 0 40px;
  @media (max-width: 768px) {
    padding: 30px 0;
  }
  .cnt{
    max-width: 1024px;
  }
  .cop-title{
    font-size: 26px;
    margin: 0 0 40px;
    @media (max-width: 768px) {
      margin: 0 0 20px;
    }
  }
  .content-title{
    font-size: 26px;
    font-weight: 600;
    margin: 0 0 20px;
    @media (max-width: 768px) {
      margin: 0 0 16px;
    }
  }
  .activity{
    .activity-item{
      // margin: 0 0 60px;
      h4{
        margin: 0 0 20px;
        font-size: 20px;
        font-weight: 500;
      }
      li{
        font-size: 18px;
        margin: 0 0 20px;
        font-weight: 500;
      }
      .quote{
        padding: 10px 0 10px 24px;
        border-left: #444 3px solid;
        font-size: 17px;
      }
    }
  }
  &.loading{
    .cop-title{
      background-color: #e5e5e5;
      color: #e5e5e5;
      width: 300px;
      max-width: 90%;
      white-space: nowrap;
      overflow: hidden;
      border-radius: 5px;
    }
    .content-title{
      height: 30px;
      background-color: #e5e5e5;
      color: #e5e5e5;
      width: 460px;
      max-width: 90%;
      white-space: nowrap;
      overflow: hidden;
      border-radius: 5px;
    }
    .the-content{
      min-height: 640px;
      .l1, .l2, .l3{
        height: 20px;
        margin-bottom: 10px;
        background-color: #e5e5e5;
        color: #e5e5e5;
        width: 460px;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        border-radius: 5px;
      }
      .l1{
        width: 600px;
      }
      .l2{
        width: 80%;
      }
      .l3{
        width: 100%;
      }
    }
  }
}

.more-cop{
  background-color: #000;
  color: #fff;
  padding: 60px 0 80px;
  margin-top: 40px;
  @media (max-width: 768px) {
    padding-top: 36px;
  }
  .cnt{
    max-width: 1024px;
  }
  .more-title{
    font-size: 34px;
    margin: 0 0 26px;
    @media (max-width: 768px) {
      font-size: 26px;
      margin: 0 0 16px;
    }
  }
  .more-cnt{
    display: flex;
    gap: 40px;
    @media (max-width: 940px) {
      gap: 20px;
    }
    @media (max-width: 768px) {
      display: block;
    }
    .more-item{
      width: 33.33333%;
      min-height: 380px;
      background-color: #444;
      padding: 24px;
      display: block;
      color: #fff;
      position: relative;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      @media (max-width: 768px) {
        width: auto;
        margin: 0 0 20px;
      }
      &::before{
        content: "";
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        background-color: rgba($color: #000000, $alpha: .4);
        opacity: .4;
        transition: all .2s ease;
      }
      &:hover{
        &::before{
          backdrop-filter: blur(20px) saturate(2);
          opacity: 1;
        }
      }
      h4{
        margin: 0;
        position: relative;
        z-index: 3;
        display: inline-block;
        font-size: 20px;
        font-weight: 500;
        img{
          height: 20px;
          float: right;
          margin: 4px 0 0 8px;
        }
      }
    }
  }
}

.cop29-team{
  .team-title{
    font-size: 30px;
    margin: 0 0 20px;
    @media (max-width: 768px) {
      font-size: 26px;
    }
  }
  .team-cnt{
    display: flex;
    gap: 20px;
    @media (max-width: 768px) {
      display: block;
    }
    .team-item{
      width: 25%;
      border-bottom: #222 2px solid;
      @media (max-width: 768px) {
        width: auto;
        margin: 0 0 60px;
      }
      .team-img{
        border: #ccc 1px solid;
        height: 240px;
        background-size: cover;
        background-position: top center;
        background-repeat: no-repeat;
        @media (max-width: 768px) {
          height: 280px;
        }
      }
      .team-info{
        padding: 12px 0 20px;
        h4{
          font-size: 17px;
          margin: 0 0 3px;
          font-weight: 500;
        }
        p{
          margin: 0;
          font-size: 15px;
          line-height: 1.3;
          opacity: .76;
        }
      }
    }
  }
}

.contact-cop29{
  padding: 60px 0 80px;
  @media (max-width: 768px) {
    padding: 10px 0 50px;
  }
  .cnt{
    max-width: 1024px;
    .contact-cnt{
      padding: 50px 60px 180px;
      background-color: #999;
      color: #fff;
      position: relative;
      @media (max-width: 768px) {
        padding: 24px 24px 74px;
      }
      &::before{
        content: "";
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        background-image: linear-gradient(to right, rgba(0,0,0,.8), rgba(0,0,0,.2));
      }
      .contact-info{
        position: relative;
        z-index: 3;
        font-size: 14px;
        margin: 0 0 18px;
        @media (max-width: 768px) {
          font-size: 13px;
          margin: 0 0 10px;
        }
        .contact-icon{
          float: left;
          svg{
            height: 18px;
            margin: 0 6px 0 0;
            @media (max-width: 768px) {
              height: 15px;
              margin-top: 2px;
            }
          }
        }
      }
      h4{
        position: relative;
        z-index: 3;
        margin: 0;
        font-size: 26px;
        font-weight: 500;
        max-width: 560px;
        line-height: 1.6;
        color: inherit;
        @media (max-width: 768px) {
          font-size: 18px;
          line-height: 1.4;
        }
        a{
          color: inherit;
        }
      }
    }
  }
}

.authorInfo{
  position: relative;
  padding-top: 8px;
  // padding-left: 50px;
  padding-bottom: 20px;
  @media (max-width: 700px) {
    padding-bottom: 16px;
  }
  .authorImg{
    position: absolute;
    left: 0;
    top: 8px;
    width: 39px;
    height: 39px;
    background-color: #ccc;
    background-image: url(../assets/user.png);
    background-size: cover;
    border-radius: 50%;
    cursor: pointer;
    display: none;
  }
  h4{
    margin: 0 0 2px !important;
    font-size: 17px !important;
  }
  .publishTime{
    margin: 0;
    font-size: 14px;
    .bull{
      margin: 0 6px;
    }
    .reading-time__word-count{
      display: none;
    }
  }
}

.articleShare{
  position: absolute;
  top: 160px;
  left: calc(((100% - 750px) / 2) - 80px);
  padding: 0 10px 5px;
  background-color: #f5f5f5;
  border-radius: 5px;
  // margin-top: 10px;
  @media (max-width: 960px) {
    margin-left: 20px;
  }
  &.articleShareStatic{
    padding-top: 40px;
    padding-bottom: 0;
    margin-left: 0;
    display: flex;
    @media (min-width: 975px) {
      // display: none;
    }
    &.articleShareBottom{
      display: block;
      height: auto;
      position: static;
      padding: 0;
      margin: 0;
      h4{
        text-align: left;
        margin: 0;
        text-transform: none;
        font-size: 16px;
      }
      .shareCnt{
        display: flex;
        flex-wrap: wrap;
        margin-left: -6px;
        a{
          margin: 0;
          margin-right: 10px;
        }
      }
    }
    &.articleShareStaticMedia{
      display: flex !important;
      position: static;
      left: 0; top: auto;
      transform: none;
      border-radius: 0;
      flex-wrap: wrap;
      padding: 0 0 20px;
      margin: 0;
      h4{
        padding: 0;
        width: 100%;
        text-align: left;
        margin: 0;
        font-size: 17px;
        text-transform: none;
      }
      .shareCnt{
        display: flex;
        margin-left: -5px;
        a{
          margin: 0;
          margin-right: 10px;
          padding: 0;
          .fa{
            margin: 0;
          }
        }
      }
    }
  }
  h4{
    margin: 0 0 10px;
    font-size: 10px;
    text-align: center;
    text-transform: uppercase;
    color: #767676;
  }
  a{
    display: block;
    .fa{
      width: 40px;
      height: 40px;
      display: block;
      border-radius: 50%;
      margin: 0 auto;
      margin-top: 4px;
      background-size: 26px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .5;
      &:hover{
        background-color: #fff;
        opacity: 1;
      }
    }
    .fa.fa-facebook{
      background-image: url(../assets/share-facebook.png);
    }
    .fa.fa-twitter{
      background-image: url(../assets/share-x.png);
    }
    .fa.fa-whatsapp{
      background-image: url(../assets/share-whatsapp.png);
    }
    .fa.fa-telegram{
      background-image: url(../assets/share-telegram.png);
    }
    .fa.fa-email{
      background-image: url(../assets/share-email.png);
    }
  }
  // @media (max-width: 974px) {
    position: static;
    display: flex;
    left: 0;
    top: auto;
    transform: none;
    bottom: 70px;
    border-radius: 0;
    flex-wrap: wrap;
    padding: 20px 0 0;
    display: none;
    h4{
      width: 50px;
      padding-top: 6px;
      width: 100%;
      text-align: left;
      margin-bottom: 6px;
      font-size: 17px;
      text-transform: none;
    }
    .shareCnt{
      display: flex;
      margin-left: -5px;
      a{
        margin: 0;
        margin-right: 10px;
        padding: 0;
        .fa{
          margin: 0;
        }
      }
    }
  // }
}

.articleHeaderImg{
  height: 34vw;
  background-size: cover;
  background-position: center;
  background-color: #ccc;
  background-repeat: no-repeat;
  max-width: 1140px;
  margin: 0 auto 30px;
  border-radius: 5px;
  @media (max-width: 1180px) {
    max-width: 960px;
  }
  @media (max-width: 1020px) {
    max-width: none;
    border-radius: 0;
    height: 36vw;
  }
  @media (max-width: 680px) {
    height: 46vw;
  }
  @media (max-width: 540px) {
    height: 220px;
  }
  &.full{
    background-image: none !important;
    height: auto;
    img{
      width: 100%;
      display: block;
      border-radius: 5px;
    }
  }
  &.noImg{
    background-color: #d5d5d5;
    background-image: url(../assets/no-img-big.jpg);
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 1;
  }
  &.protected{
    position: relative;
    overflow: hidden;
    &:before{
      content: "";
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      background-color: #000;
      opacity: .24;
    }
    &.noImg{
      background-image: none !important;
      background-color: #ccc !important;
    }
    .protectedContent{
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      &:before{
        content: "";
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        background-color: #000;
        opacity: .18;
      }
      .protectedContentIn{
        position: relative;
        z-index: 3;
        img{
          width: 54px;
        }
        h4{
          margin: 0;
          font-weight: 400;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
